import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './HermesHeader.less';
import Cart from '../../../shared-components/Cart/Cart';


export class HermesHeader extends Component {
    static propTypes = {
        merchantBanner: PropTypes.object,
        country: PropTypes.string,
        isMobile:PropTypes.bool.isRequired,
        currentPage:PropTypes.string,
        cartAmount:PropTypes.string,
        isMemberFlow:PropTypes.bool
    };


    isTransactional(cartAmount) {
        if (cartAmount && cartAmount != '0') {
            return true;
        }
    }

    render() {
        const { merchantBanner, country, isMobile, currentPage, cartAmount, isMemberFlow } = this.props;
        let merchantLogo;
        let htmlRender;
        const isTransactional = this.isTransactional(cartAmount);
        const isSepa = currentPage === 'sepapage';


        const logoImageUrl = merchantBanner.logoUrl || merchantBanner.bannerUrl;

        if (logoImageUrl) {
            merchantLogo = (
                <img id="headerImg"
                    src={logoImageUrl}
                    alt={merchantBanner.brandName}
                />
            );
        } else {
            merchantLogo = merchantBanner.brandName || merchantBanner.merchantEmail;
        }

        if (country === 'de') {
            // In DE, neither the member or guest (deprecated) flow render the hermes banner anymore
            htmlRender = null;
        } else {
            htmlRender = (
                <header>
                    <div className="merchantHeader hide-for-mobile">
                        <div className="headerWrapper">
                            <span className="merchantName"> {merchantLogo} </span>
                        </div>
                    </div>
                </header>
            );
        }

        return (
            <div>
                {htmlRender}
            </div>
        );
    }
}

export const mapStateToProps = state => {
    return {
        merchantBanner: _.get(state, 'serverData.merchantBanner', {}),
        cartAmount: _.get(state, 'serverData.cart.subtotal'),
        country: _.get(state, 'serverData.country'),
        isMobile: _.get(state, 'serverData.isMobile', false),
        currentPage: _.get(state, 'skeletonPage.currentPage', ''),
        isMemberFlow: _.get(state, 'serverData.isMemberFlow', false)
    };
};

export default connect(mapStateToProps)(HermesHeader);
